module.exports = __webpack_public_path__ + "static/media/han-solo.22c592cd.jpg";